export default __webpack_public_path__ + "static/media/lee-jae-woo.17163fb3.jpg";